import { ReactNode, useState } from 'react';

import styled from '@emotion/styled';

import CheckMarkIcon from '../../../components/Icons/CheckMarkIcon';
import CheckRounded from '../../../components/Icons/CheckRounded';
import InfoRounded from '../../../components/Icons/InfoRounded';
import { Modal } from '../../../components/Modal/Modal';
import LookupModal from '../../../components/Modal/ModalActions/LookupModal/LookupModal';
import { useAppSelector } from '../../../redux/store';

type NoticeVariant = 'info' | 'success' | 'warning' | 'error';

interface NoticeProps {
  variant?: NoticeVariant;
  message: string;
}

const ICON_MAP: Record<NoticeVariant, ReactNode> = {
  info: <InfoRounded />,
  success: <CheckRounded />,
  warning: <CheckMarkIcon />,
  error: <CheckMarkIcon />,
};

export default function Notice({ variant = 'info', message }: NoticeProps) {
  const [showModal, setShowModal] = useState(false);
  const { kycStatusData } = useAppSelector((state) => state.kycStatusData);
  // const { lookupCountData } = useAppSelector((state) => state.lookupCountData);

  return (
    <Container variant={variant}>
      {/* <Left> */}
      <IconWrapper variant={variant}>{ICON_MAP[variant]}</IconWrapper>
      <Message>{message}</Message>

      {
        kycStatusData?.kycStatus === 'Accepted' && (
          // lookupCountData?.totalAvailableLookupCount === 0 && (
          <PurchaseModalButton onClick={() => setShowModal(true)}>
            Purchase
          </PurchaseModalButton>
        )
        // )
      }
      <Modal showModal={showModal} setShowModal={setShowModal}>
        <LookupModal />
      </Modal>
    </Container>
  );
}

const variantStyles = {
  info: {
    bg: '#3B7CF40D',
    color: '#3B7CF4',
  },
  success: {
    bg: '#F0FDF4',
    color: '#16A34A',
  },
  warning: {
    bg: '#FFFBEB',
    color: '#D97706',
  },
  error: {
    bg: '#FEF2F2',
    color: '#DC2626',
  },
};

export const Container = styled.div<{ variant: keyof typeof variantStyles }>`
  display: flex;
  align-items: center;
  gap: 16px;

  padding: 14px 16px;
  border-radius: 6px;
  background: ${({ variant }) => variantStyles[variant].bg};
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const IconWrapper = styled.div<{ variant: keyof typeof variantStyles }>`
  color: ${({ variant }) => variantStyles[variant].color};
  display: flex;
  align-items: center;
`;

export const Message = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

export const Action = styled.div`
  display: flex;
  align-items: center;

  button {
    padding: 8px 14px;
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background: white;
    font-weight: 500;
    cursor: pointer;
  }
`;

const PurchaseModalButton = styled.button`
  display: flex;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 6px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.blueColor};
  background-color: white;
  padding: 8px;
  margin-left: auto;

  cursor: pointer;
`;
